import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import useFetchCauseCategories from '../../hooks/fetchCauseCategories';
import { message, Upload, Switch, Select, TimePicker,DatePicker, Form, Input } from 'antd';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { LeftCircleOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {app} from '../../config';
import moment from "moment";
import getPrayerById from '../../hooks/getPrayerById';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
const { TextArea } = Input;

const Editprayer = () => {
  dayjs.extend(customParseFormat);
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  const [addUserResp,setAddUserResp] = useState({});
  const [show, setShow] = useState(false); 
  let user=JSON.parse(localStorage.getItem('user'));
  console.log(user);
  let prayerId =JSON.parse(localStorage.getItem('prayerId'));
  let prayerResp=getPrayerById(prayerId);
  let prayerObj=prayerResp.response?prayerResp.response.data:null;
  console.log(prayerObj);
  let navigate = useNavigate();
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  };
const token = getTokenfromUserObj()
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );
  const orgResp = useFetchOrganizations();
  const orgs = orgResp.response ? orgResp.response.data : [];
  console.log(orgs);
  const uploadData=async(uploadObj)=>{
    try {
      console.log(uploadObj);
      const res = await axios.post(`${app.URL}/prayertime/update/${prayerId}`, uploadObj,{headers:{auth:token}});
      if (res.data.statusCode===200){
        setAddUserResp(res.data)
        setTimeout(()=>{
          if(user.userType==="A")navigate('/prayer/view', { replace: true });
          else if(user.userType==="O")navigate('/prayers/view', { replace: true });
        },1000)
      } 
    } catch (err) {
      console.log(err);
      // if (err) window.alert(err.response.data.data.message);
      // else retrun;
    }
  }

  const onFinish = (values) => {
    console.log('Success:', values);
    // console.log(values.startTime.$d.toLocaleTimeString())
    setUploadObj({
      prayer: values.prayer ? values.prayer :prayerObj.prayer,
      organizationId:  user.userType==="A" && values.organizationId ? values.organizationId : prayerObj.organizationId,
       comment:values.comment ? values.comment:null,
      startTime:values.startTime  ? (values.startTime._d).toTimeString().split(' ')[0] : prayerObj.startTime,
      endTime:values.endTime  ? (values.endTime._d).toTimeString().split(' ')[0] :prayerObj.endTime,
      iqamahTime:values.iqamahTime  ? (values.iqamahTime._d).toTimeString().split(' ')[0] :prayerObj.iqamahTime,
      isActive: values.isActive === true ? 1 : 0,
      createdByUserId:user.userId
    });
    setShow(true);
  };

  // if(Object.keys(uploadObj).length>0){
  //     console.log(true)
  //     uploadData(uploadObj);

  // }
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const submitData=()=>{
    console.log('calling')  
    console.log(uploadObj);
    if (Object.keys(uploadObj).length > 0) {
          uploadData(uploadObj);
  }
}
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);

  function goBack() {
    if(user.userType==="A")navigate('/prayer/view', { replace: true });
    else if(user.userType==="O")navigate('/prayers/view', { replace: true });
   }
   window.addEventListener('popstate', goBack);
  const onChange = (time, timeString) => {
    console.log(time, timeString);
  };
  const c = useFetchCauseCategories();
  console.log(c);
  let causes = c ? c.response : [];
  console.log(causes);
  const renderList = []; //For testing purposes
  return (
    <div class='container'>
    <div class='row mt-4 w-75 tbl'>
    <div class='row topbar ' style={{ height: '70px' }}>
          <div class='col-lg-4 fs-3 fw-bold'>
            {' '}
            
            <LeftCircleOutlined
              onClick={() => {
                if(user.userType==="A")navigate('/prayer/view', { replace: true });
                else if(user.userType==="O")navigate('/prayers/view', { replace: true });
              }}
              className='mt-3 ml-4 back-icon'
              style={{ fontSize: '38px' }}
            />
          </div>
          <div class='col-lg-7 fs-3 fw-bold '>
            <h2 class=' mb-5 mt-4 fw-bold text-white fs-4 ml-4'> {t('Update Prayer')} </h2>
          </div>{' '}
        </div>
      <div class="col-lg-11 mb-5 mt-3 ">
      <div class='col-lg-9 align-self-center mt-2 mb-4'>
      {prayerResp.response?<Form
          name='basic'
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
            ['id']: 1,
            ['prayer']: prayerObj.prayer,
            ['organizationId']: prayerObj.organizationId,
            ['comment']:prayerObj.comment,
            ['startTime']:moment(prayerObj.startTime, 'HH:mm:ss') ,
            ['endTime']:moment(prayerObj.endTime, 'HH:mm:ss'),
            // ['causeCategory']: `${causeCat.length > 0 ? causeCat[0].cause_category : ''}`,
            ['isActive']: prayerObj.isActive===1?true:false,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          {user.userType==="A"?<Form.Item
            label='Organization'
            name='organizationId'
            rules={[
              {
                required: true,
                message: 'Select organization',
              },
            ]}
          >
            <Select
              listHeight={250}
              listItemHeight={500}
              placeholder="Select Organization"
              style={{
                width: 260,
              }}
            >
              {orgs.map((orgs) => {
                return (
                  <Option key={orgs.organizationId} value={orgs.organizationId}>
                    {orgs.organizationName}
                  </Option>
                );
              })}
            </Select>
          </Form.Item> :""}
                    
          <Form.Item  
               colon={false}
            label='Prayer Name'
            name='prayer'
            rules={[
              {
                required: true,
                message: 'Enter Prayer',
              },
            ]}
          >
            <Input placeholder='Enter Prayer' />
          </Form.Item>
          <Form.Item  
        colon={false}
        label='Comment'
        name='comment'
        rules={[
          {
            required: false,
            message: 'Enter Prayer Name',
          },
        ]}
      >
        <Input placeholder='Enter comments' />
      </Form.Item>
          <Form.Item
               colon={false}
            label='Start Time'
            name='startTime'
            rules={[
              {
                required: true,
                message: 'Enter Start Time',
              },
            ]}
          >
             <TimePicker placeholder='Enter Start Time' defaultValue={moment(prayerObj.startTime, 'HH:mm:ss')}  />
          </Form.Item>
          <Form.Item
               colon={false}
            label='End Time'
            name='endTime'
            rules={[
              {
                required: true,
                message: 'Enter End Time',
              },
            ]}
          >
             <TimePicker placeholder='Enter End Time'defaultValue={moment(prayerObj.endTime, 'HH:mm:ss')} />
          </Form.Item>
          <Form.Item
            colon={false}
            label='Iqamah Time'
            name='iqamahTime'
            rules={[
              {
                required: false,
                message: 'Please select date!',
              },
            ]}
          >
             <TimePicker defaultValue={prayerObj.iqamahTime?moment(prayerObj.iqamahTime, 'HH:mm:ss'):moment("Test", 'HH:mm:ss')} />
          </Form.Item>
         
          <Form.Item label='Active'     colon={false} valuePropName='checked' name='isActive'>
            <Switch />
          </Form.Item>
        
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
              {addUserResp.statusCode===200? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>:addUserResp.statusCode===400? <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className='text-center'>Failed</Modal.Title>
        </Modal.Header>
        <Modal.Body >{addUserResp.data.message}</Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal> : <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body >Are you sure you want to update Prayer?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary"  htmlType='submit' onClick={submitData}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>}
            <button type='primary' class='btn btn-primary button' htmlType='submit'>
           Update
            </button>

          </Form.Item>
        </Form> :""}  
      </div>
      </div>
    </div>
  </div>
  );
};

export default Editprayer;
